/**
 * Localismo del mundo
 */
export default class WorldLocale {
    public identifier: string = ''
    public name: string = ''

    constructor (identifier: string, name: string) {
        this.identifier = identifier
        this.name = name
    }

    get composedName (): string {
        return `${this.identifier} - ${this.name}`
    }
}
